export enum CallType {
  REGULAR_CALL = 'REGULAR_CALL',
  TEAMING_REGULAR_CALL = 'TEAMING_REGULAR_CALL',
  TEAMING_CONFERENCE_CALL = 'TEAMING_CONFERENCE_CALL',
  CONFERENCE_CALL = 'CONFERENCE_CALL',
  EMERGENCY_CALL = 'EMERGENCY_CALL',
  COLD_HANDOFF_CALL = 'COLD_HANDOFF_CALL',
}
